import api from "@/shared/utils/api";
import { settings } from "@/shared/utils/settings";

export interface Tariff {
  id: string;
  _id: string;
  name: string;
  uid: string;
  description: string;
  is_active: boolean;
  price: number;
  features: string[];
  monthly_request_limit: number;
}

export class TariffService {
  /**
   * Get all tariffs
   * @returns Promise with all tariffs
   */
  static async getAll(): Promise<Tariff[]> {
    try {
      const response = await api.get(settings.api.tariffs);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch tariffs:", error);
      throw error;
    }
  }
}
